import * as React from 'react'; 
import { PanelLeft } from 'lucide-react';
import Breadcrumbs, { BreadcrumbItemData } from '../breadcrumbs/mss-breadcrumbs';

interface HeaderProps {
  initialBreadcrumbs?: BreadcrumbItemData[];
}

export default function MssHeader({ initialBreadcrumbs = [] }: HeaderProps) {
  const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbItemData[]>(initialBreadcrumbs);

  React.useEffect(() => {
    if (initialBreadcrumbs.length > 0) setBreadcrumbs(initialBreadcrumbs);
  }, [initialBreadcrumbs]);

  React.useEffect(() => {
    const handleUpdate = (e: CustomEvent<{ items: BreadcrumbItemData[] }>) => {
      if (e.detail?.items) setBreadcrumbs(e.detail.items);
    };
    window.addEventListener('smb:breadcrumbs-update', handleUpdate as EventListener);
    return () => window.removeEventListener('smb:breadcrumbs-update', handleUpdate as EventListener);
  }, []);

  const displayBreadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : [{ label: 'Dashboard', active: true }];

  return (
    <div className="flex items-center gap-2 md:gap-4 min-w-0 overflow-hidden">
      <button
        onClick={() => window.dispatchEvent(new CustomEvent('smb:sidebar-toggle'))}
        className="p-2 hover:bg-zinc-100 rounded transition-colors bg-white border-none shrink-0"
        aria-label="Toggle sidebar"
      >
        <PanelLeft className="w-4 h-4" />
      </button>
      <div className="min-w-0 overflow-hidden">
        <Breadcrumbs items={displayBreadcrumbs} />
      </div>
    </div>
  );
}
